<style>
#generateRaport .values-list__element {
  padding-top: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid lightgrey;
  display: flex;
  justify-content: flex-start;
  line-height: 32px;
}
#generateRaport * {
  font-size: 12px;
}
</style>

<template>
  <Modal
    modalName="generateRaport"
    title="Wygeneruj raport"
    :buttons="['save']"
    @saved="createRaport"
  >
    <div id="wrapper">
      <v-flex xs12>
        <v-text-field
          label="Adres"
          v-model="address"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          label="Opis"
          v-model="description"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          label="Wykonał"
          v-model="author"
        ></v-text-field>
      </v-flex>
      <div class="list--container">
        <v-subheader style="font-size: 14px !important">Lista klientów do odcięcia</v-subheader>
        <ul
          id="values-list"
          v-if="watermeters.length > 0"
        >
          <li class="values-list__element">
            <v-flex xs5>
              <span
                class="font--primary"
                style="font-weight: 600"
              >Identyfikator wodomierza</span>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <span
                class="font--primary"
                style="font-weight: 600"
              >Numer wodomierza</span>
            </v-flex>
          </li>
          <template v-for="w in watermeters">
            <li
              :key="w.IdWodomierz"
              v-if="w.IdWodomierz != null"
              class="values-list__element"
            >
              <v-flex xs5>
                <span class="font--primary">{{w.IdWodomierz}}</span>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <span class="font--primary">{{w.NrWodomierz}}</span>
              </v-flex>
            </li>
          </template>
        </ul>
        <span v-else>Brak klientów do odcięcia</span>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import {transform} from "ol/proj.js";

export default {
  components: {
    Modal
  },
  data: () => ({
    watermeters: [],
    coords: [],
    valves: [],
    address: undefined,
    description: undefined,
    dataFromCutoff: undefined,
    author: undefined
  }),
  computed: {
    currentBasemap() {
      return this.$store.getters.getCurrentBasemap;
    },
    currentUser() {
      return this.$store.getters.getCurrentUsername;
    }
  },
  methods: {
    assignData(data) {
      this.coords = data[0];
      this.valves = data[1].valves;
      this.watermeters = data[1].watermeters;
      this.dataFromCutoff = data[1];
    },
    createRaport() {
      this.$root.$emit("showSnackbar", "#2a579a", `Trwa generowanie raportu`);
      this.coords = transform(
        [this.coords[0], this.coords[1]],
        "EPSG:2180",
        this.$store.getters.getSrid
      );
      const payload = {
        address: this.address,
        author: this.author,
        description: this.description,
        layers: {
          basemap: this.currentBasemap === 'Brak' ? null :  this.currentBasemap
        },
        location_x: this.coords[0],
        location_y: this.coords[1],
        partitions: this.dataFromCutoff.partitions,
        pipes: this.dataFromCutoff.pipes,
        terminals: this.dataFromCutoff.terminals,
        valves: this.valves,
        watermeters: this.dataFromCutoff.watermeters
      };
      this.$store.dispatch("generateCutoffRaport", payload).then(res => {
        if(res.status === 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "raport.pdf");
          document.body.appendChild(link);
          link.click();
          this.close();
        }
      }).catch(e => {
        const res = JSON.parse(Buffer.from(e.response.data).toString('utf8'));
        this.$root.$emit("showSnackbar", "red", res.message);
      })
    },
    close() {
      this.$modal.hide("generateRaport");
      this.watermeters = [];
      this.coords = [];
      this.valves = [];
      this.address = undefined;
      this.description = undefined;
      this.dataFromCutoff = undefined;
    }
  },
  mounted() {
    this.$root.$on("generateRaport", this.assignData);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/analysis/modals/GenerateRaport.vue